import React, { Fragment, useState } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import Modal from './Modal';
import Error from '../../asset/img/icon_error.svg';
// import CheckOn from "../../asset/img/icon_checkbox_on.svg"
// import CheckOff from "../../asset/img/icon_checkbox_off.svg"
import Terms3 from './Terms3';
const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    padding: ' 14px 16px',
    position: 'fixed',
    bottom: '22px',
    placeContent: 'center',
  },
  modalButtonLeft: {
    paddingRight: '4px',
  },
  modalButtonRight: {
    paddingLeft: '4px',
  },
  modalButton: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    // margin: "0px 4px",
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0px',
    fontWeight: 'bold',
  },
  modalGridContainer: {},
  modalGridItemLabel: {
    padding: '5px 14px 0px 14px',
  },
  modalGridItem: {
    padding: '12px 14px',
  },
  modalLabel: {
    // minHeight: "20px",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', // "#da0f47"
    },
  },
  modalField: {
    // paddingTop: "12px",
    '& input': {
      borderRadius: '6px',
      width: '100%',
      height: '46px',
      border: 'solid 1px #929292',
      padding: '13px 16px',
    },
  },
  modalPlainBtn: {
    minHeight: '46px',
    borderRadius: '6px',
    border: 'solid 1px #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0px',
    paddingRight: '8px',
  },
  modalInnerItemLast: {
    paddingRight: '0px',
  },
  infoIcon: {
    width: '16px',
    height: '16px',
  },
  textareaField: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: '150px',
    borderRadius: '6px',
    background: '#fff',
    font: 'inherit',
    fontSize: '14px',
    padding: '13px 16px 35px',
  },
  textCount: {
    font: 'inherit',
    fontSize: '12px',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '14px',
    right: '16px',
  },
  nextLine: {
    paddingBottom: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0px !important',
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '120px',
    overflowY: 'auto',
    border: '1px solid #929292',
    borderRadius: '6px 6px 0 0',
    fontSize: theme.font.size12,
    padding: '16px',
    lineHeight: '18px',
  },
  termTextTitle: {
    fontWeight: 'bold',
  },
  checkArea: {
    height: '48px',
    border: '1px solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 6px 6px',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    '& label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
    },
    '& input': {
      height: '20px',
      width: '20px',
      marginRight: '6px !important',
    },
    '& input.error': {},
  },
  errorIcon: {
    width: '12px',
    height: '12px',
    color: '#ff3723',
    marginRight: '3px',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
  },
  error: {
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
});

function Retrieve(props) {
  const { classes, data, modalOpen, modalClose } = props;

  const Input = withStyles(styles)((props) => {
    const { classes, placeholder, errorText = placeholder } = props;
    return (
      <Fragment>
        <input type="text" placeholder={placeholder} className={classes.error} />
        <div className={classes.errorText}>
          <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
          {errorText}
        </div>
      </Fragment>
    );
  });

  const RetrieveModal = (props) => {
    const { classes, modalClose } = props;
    const [termModalOpen, setTermModalOpen] = useState(false);
    const [checked, setChecked] = useState(false);
    return (
      <Fragment>
        <Grid container className={classes.modalGridContainer}>
          {/* 이름 */}
          <Grid
            item
            xs={12}
            className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
              ' '
            )}
          >
            <div className={classes.modalLabel}>
              이름<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                type="text"
                placeholder="이름을 입력해주세요."
                className={classes.error}
              />
            </div>
          </Grid>
          {/* 휴대전화번호 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>
              휴대전화번호<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input type="text" placeholder="휴대전화번호를 입력해주세요." />
            </div>
          </Grid>
          {/* 개인정보 수집 및 이용동의 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={[classes.modalLabel, classes.terms].join(' ')}>
              <div>
                개인정보 수집 및 이용동의<span className="star">*</span>
              </div>
              <button className={classes.showAll} onClick={() => setTermModalOpen(true)}>
                button
              </button>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={[classes.modalField, classes.textareaField].join(' ')}>
              <div className={classes.termTextArea}>
                <div className={classes.termTextTitle}>1. 개인정보의 수집 항목</div>
                <div className={classes.termTextContent}>
                  LG전자 주식회사(이하 ‘회사’라 합니다)는 LG전자 상담 챗봇 서비스 이용을
                  위해 아래와 같은LG전자 주식회사(이하 ‘회사’라 합니다)는 LG전자 상담 챗봇
                  서비스 이용을 위해…
                </div>
              </div>
              <div className={classes.checkArea}>
                <label>
                  <input
                    type="checkbox"
                    checked={checked}
                    onClick={() => {
                      setChecked((prev) => !prev);
                    }}
                  />
                  동의합니다.
                </label>
              </div>
            </div>
            <div className={classes.errorText}>
              <img src={Error} className={classes.errorIcon} alt="체크 필요" />
              먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.
            </div>
          </Grid>
        </Grid>
        {/* footer button */}
        <Grid container className={classes.modalFooter} spacing={1}>
          <Grid item xs={6} className={classes.modalButtonLeft}>
            <button className={classes.modalButton} onClick={() => modalClose()}>
              취소
            </button>
          </Grid>
          <Grid item xs={6} className={classes.modalButtonRight}>
            <button
              className={[classes.modalButton, classes.modalButtonStrong].join(' ')}
            >
              확인
            </button>
          </Grid>
        </Grid>
        <Terms3
          modalOpen={termModalOpen}
          modalClose={() => setTermModalOpen(false)}
          checkOk={(ok) => {
            setChecked(ok);
          }}
        />
      </Fragment>
    );
  };

  return (
    <div className={classes.root}>
      <Modal
        component={withStyles(styles)(RetrieveModal)}
        anchor="bottom"
        title="예약 확인/취소"
        data={data}
        modalOpen={modalOpen}
        modalClose={modalClose}
        height="100%"
        borderRadius="0px"
        closeType="close"
      />
    </div>
  );
}
export default withStyles(styles)(Retrieve);
